import { Box, Typography } from "@mui/material";
import React, { useRef } from "react";
import "../Home/Home.css";
import Card from "../../components/Elements/Card/Card";
import "../Service/Service.css";
import "../Service/Services.css";
import "../AboutUs/AboutUs.css";
import "../Home/Home.css";
import Icon from "../../components/Elements/Icon/Icon";
import Images from "../../constant/images";
import "../Employer/Employer.css";
import { useTranslation } from "react-i18next";
import { ClientTestimonial } from "../../components/TestimonialCarousel/clientTestimonial";
import ServiceCarousel from "../../components/TestimonialCarousel/serviceCarousel";

const HrSolution = () => {
  const { t } = useTranslation();
 

  const cards = [
    {
      number: "1",
      title: "Employee Records Management",
      description: [
        "Maintaining accurate and up-to-date records for all employees (e.g., personal details, employment history, benefits enrollment, performance appraisals).",
      ],
    },
    {
      number: "2",
      title: "Payroll Administration:",
      description: [
        "Managing employee salaries, benefits, bonuses, and ensuring timely payment.",
        " Handling tax deductions, overtime, and bonuses.",
      ],
    },
    {
      number: "3",
      title: "Administration benefits:",
      description: [
        "Managing employee benefits programs such as health insurance, retirement plans, and vacation policies.",
        "Ensuring that employees are enrolled in the appropriate benefit plans.",
      ],
    },
    {
      number: "4",
      title: "Compliance and Legal Documentation:",
      description: [
        "Ensuring that the company adheres to labor laws, health and safety regulations, and other  legal requirements.",
        "Managing employment contracts, termination letters, and other documentation.",
      ],
    },
    {
      number: "5",
      title: "Policy and Procedure Development:",
      description: [
        "Drafting and communicating company policies on issues like attendance, dress code, harassment, and code of conduct.",
      ],
    },
    {
      number: "6",
      title: "Employee Leave Management:",
      description: [
        "Tracking employee leave (sick leave, vacation, parental leave) and ensuring compliance with company policies.",
      ],
    },
    {
      number: "7",
      title: "HR Systems Management:",
      description: [
        "Using HR software to manage employee data, payroll, and benefits administration.",
      ],
    },
    {
      number: "8",
      title: "Reporting and Data Management:",
      description: [
        "Preparing regular reports on HR activities, such as employee turnover, payroll, and compliance audits.",
      ],
    },
  ];

  return (
    <>
      <Box className="hr-solution-container">
        <Box
          className="hr-solution-box"
        >
          <Box>
            <Icon src={Images.serviceicon} alt="" />
          </Box>
          <Box className="hr-solution-textbox">
            <Typography className="service-headding">
              Administration part of HR:
            </Typography>
            <Typography className="service-p" mt={2} width={"88%"}>
              HR administration ensures the efficient running of HR functions
              and supports the HR department in its strategic goals. It’s about
              maintaining smooth operations and compliance with all relevant
              regulations.
            </Typography>
          </Box>
        </Box>
        <Box
          // display="grid"
          // gridTemplateColumns={{ xs: "1fr", sm: "1fr 1fr" }} // 1 card per row on xs, 2 cards per row on sm+
          // gap={3} // Spacing between cards
          // mt={6}
          className="custom-grid-container"
        >
          {cards.map((card, index) => (
            <Card key={index} className="service-card">
              <Typography className="service-hedding">{card.title}</Typography>

              <ul
                className="service-ul"
              >
                {card.description.map((point, i) => (
                  <li key={i} className="service-body">
                    {point}
                  </li>
                ))}
              </ul>
            </Card>
          ))}
        </Box>
        {/*  */}
        <Box className="hr-goverment">
          <Typography className="service-headding1">
            HR Government Affairs for BAH-KSA and global visa/work permit
            clearance:
          </Typography>
          <Typography className="service-headding2" mt={2}>
            HR services can be categorized:
          </Typography>
          <Typography className="service-body1" mt={1} width={"95%"}>
            It involves navigating local regulations to ensure compliance with
            immigration and labor laws. For KSA, we work with government bodies
            like HRSD and SAGIA to secure work permits and manage legal
            requirements. Globally, we handle visa stamping, exit clearances,
            and re-entry permits, ensuring all documentation is compliant and
            processed efficiently. Our global networkof experts ensures smooth
            transitions and minimizes legal risks for employees worldwide.
          </Typography>
        </Box>
      </Box>
      <ServiceCarousel />

      {/* <Box>
      <ServiceCarousel />
      </Box>  */}
      <Box mb={5}>
        <ClientTestimonial />
      </Box>
    </>
  );
};
export default HrSolution;
